import React, { memo, useCallback } from 'react'
import url from 'front-end-core/core/url'
import { CURRENT_AWARENESS_REVIEW } from 'constants/controllers'
import { URL_PDF_CA } from 'constants/urls'
import { of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { deselectContent, observeSelected } from 'front-end-core/services/StateService'
import { shorten } from 'front-end-core/services/ShortenerService'
import SelectedHeader from 'components/shared/SelectedHeader'

const CaHeader = memo((props) => {
  const toUrl = (aol, selectedIds) => url(CURRENT_AWARENESS_REVIEW, { aol, selectedIds: selectedIds.map(v => v.replace('/', ':')) })
  const { aol } = props
  const getStateSource = useCallback(() => observeSelected('currentawareness').pipe(
    map(vs => Object.keys(vs).map(k => vs[k] > 0 ? k : null).filter(v => v !== null)),
    switchMap(
      selectedIds =>
        selectedIds.length
          ? shorten(toUrl(aol, selectedIds).replace(/#/, ''))
            .pipe(map(short => ({ selectedIds, short })))
          : of({ selectedIds: [], short: null })
    )), [aol])

  return (
    <div>
      <SelectedHeader
        {...{ ...props, stateSource: getStateSource() }}
        deselectAll={deselectContent.bind(null, 'currentawareness')}
        keyword={(l) => l === 1 ? 'article' : 'articles'}
        pdfUrl={URL_PDF_CA}
        dataHelpItem='catoolbar'
      />
      <div className='pt8 pb4 layout-width-constraint' />
    </div>
  )
})

export default CaHeader
